import React, { useState, useRef } from "react";
import { BaseConfiguration, InputFilenameAId, InputFilenameBId } from "./ConfigFormData";
import { InputIdentifier } from "./FileInput";
import { FileUploaderPresentationalComponent } from "./FileUploaderPresentationalComponent";

export interface FileUploaderProps {
    onFormDrop: (event: React.DragEvent<HTMLInputElement>, InputFileName: string) => void;
    formValues: BaseConfiguration;
    inputIdentifier: any;
}

export const FileUploader: React.FunctionComponent<FileUploaderProps> = (props) => {
    const { onFormDrop, formValues, inputIdentifier } = props;
    const [file, setFile] = useState<File | null>(null);
    const [dragEventCounter, setDragEventCounter] = useState(0);
    const fileUploaderInputRef = useRef<HTMLInputElement>(null);

    function dragenterListener(event: React.DragEvent<HTMLDivElement>) {
        overrideEventDefaults(event);
        setDragEventCounter(dragEventCounter + 1);
    }

    function dragleaveListener(event: React.DragEvent<HTMLDivElement>) {
        overrideEventDefaults(event);
        setDragEventCounter(dragEventCounter - 1);
    }

    function dropListener(event: React.DragEvent<HTMLInputElement>) {
        overrideEventDefaults(event);
        setDragEventCounter(0);

        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            setFile(event.dataTransfer.files[0]);
            if (inputIdentifier === InputIdentifier.A) {
                onFormDrop(event, InputFilenameAId);
            } else if (inputIdentifier === InputIdentifier.B) {
                onFormDrop(event, InputFilenameBId);
            }
        }
    }

    function overrideEventDefaults(event: Event | React.DragEvent<HTMLDivElement>) {
        event.preventDefault();
        event.stopPropagation();
    }

    function onSelectFileClick() {
        fileUploaderInputRef.current && fileUploaderInputRef.current.click();
    }

    function handleFileInputChange(event: any) {
        if (event.target.files && event.target.files[0]) {
            setFile(event.target.files[0]);
            if (inputIdentifier === InputIdentifier.A) { 
                onFormDrop(event, InputFilenameAId);
            } else if (inputIdentifier === InputIdentifier.B) {
                onFormDrop(event, InputFilenameBId);
            }
        }
    }


    return (
        <FileUploaderPresentationalComponent
            dragging={dragEventCounter > 0}
            file={file}
            onSelectFileClick={onSelectFileClick}
            onDrag={overrideEventDefaults}
            onDragStart={overrideEventDefaults}
            onDragEnd={overrideEventDefaults}
            onDragOver={overrideEventDefaults}
            onDragEnter={dragenterListener}
            onDragLeave={dragleaveListener}
            onDrop={dropListener}
        >
            {props.children}
            <input
                type="file"
                style={{ display: "none" }}
                ref={fileUploaderInputRef}
                onChange={handleFileInputChange}
              
            />
        </FileUploaderPresentationalComponent>
    );
};

export default FileUploader;
